<app-aumico-layout hideFooter="true">
    <ng-container *ngIf="!editMode" header>
        <ham-page-header [title]="pageHeader.value | i18next" [backButtonRoute]="['../overview']"></ham-page-header>
    </ng-container>
    <ng-container content>
        <div style="padding: 0">
            <div class="page-header">
                <span> {{ 'aumico_companies_details_text' | i18next }}</span>
                <div class="page-buttons">
                    <ham-button
                        icon="assets/hamIcons/floppy-outline.svg"
                        type="submit"
                        size="lg"
                        (buttonClick)="saveButtonClicked()"
                    >
                        {{ 'aumico_button_save' | i18next }}
                    </ham-button>
                </div>
            </div>

            <aumico-edit-company-component
                hideStatus="true"
                [legalFormOptions]="shortLegalForms$ | async"
                [originalLegalFormOptions]="originalLegalForms"
                [countryOptions]="countries"
                [industryOptions]="industryOptions"
                [currentLanguage]="currentLanguage"
                [defaultLanguage]="defaultLanguage"
                [organizationUsers]="organizationUsers$ | async"
                [proceedButtonEvent$]="proceedButtonEvent$"
                [save$]="saveCompany.asObservable()"
                [defaultCountry]="defaultCountry"
                [activeCompany]="activeCompany"
                [canManageFx]="(canManageFx$ | async) ?? false"
                [workflowOptions]="workflows"
                [organizationHasCpmmActive]="organizationHasCpmmActive"
                [organizationHasMandateAndTaskManagementEnabled]="organizationHasMandateAndTaskManagementEnabled"
                (createdCompany)="setCreatedCompany($event)"
                (isFormValid)="enableProceedButton($event)"
                (error)="handleErrors($event)"
                (countrySelectionChange)="onCountrySelectionChange($event)"
            ></aumico-edit-company-component>
        </div>
    </ng-container>
</app-aumico-layout>
